var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import createPersistedState from "use-persisted-state";
export var useThirdPartyAPIEndpoints = function () {
    var defaultThirdPartyAPIEndpoints = [];
    var _a = createPersistedState("ADDRESS_THIRD_PARTY_ENDPOINTS")(defaultThirdPartyAPIEndpoints), thirdPartyAPIEndpoints = _a[0], setThirdPartyAPIEndpoints = _a[1];
    var addThirdPartyAPIEndpoint = function (newValues) {
        setThirdPartyAPIEndpoints(__spreadArrays(thirdPartyAPIEndpoints, [newValues]));
    };
    var removeThirdPartyAPIEndpoint = function (id) {
        var filtered = thirdPartyAPIEndpoints.filter(function (item, index) {
            return index !== id;
        });
        setThirdPartyAPIEndpoints(filtered);
    };
    return { thirdPartyAPIEndpoints: thirdPartyAPIEndpoints, setThirdPartyAPIEndpoints: setThirdPartyAPIEndpoints, addThirdPartyAPIEndpoint: addThirdPartyAPIEndpoint, removeThirdPartyAPIEndpoint: removeThirdPartyAPIEndpoint };
};
//# sourceMappingURL=useThirdPartyAPIEndpoints.js.map